import { gql, useLazyQuery } from "@apollo/client";
import { SearchSelect } from "./SearchSelect";
import { Select_SearchSupplierProductsQuery, Select_SearchSupplierProductsQueryVariables } from "../../../../codegen/graphql";

const SEARCH_SUPPLIER_PRODUCTS = gql`
  query Select_SearchSupplierProducts($search: String!, $supplierType: String) {
    supplierProducts(search: $search, supplierType: $supplierType, page: 1, pageSize: 10) {
      nodes {
        id
        name
      }
    }
  }
`;

export default function SupplierProductSearchSelect({
  selectedSupplierProduct,
  onSupplierProductChange,
  supplierType,
  linkedToAdVariationId,
}: {
  selectedSupplierProduct: { value: string, label: string } | null;
  onSupplierProductChange: (supplierProduct: { value: string, label: string } | null) => void;
  supplierType?: string;
  linkedToAdVariationId?: string;
}) {
  const [searchAds, { data: adsData }] = useLazyQuery<
  Select_SearchSupplierProductsQuery,
  Select_SearchSupplierProductsQueryVariables
  >(
    SEARCH_SUPPLIER_PRODUCTS
  );

  // Load ads for search
  const loadAds = async (searchText: string) => {
    if (searchText.trim().length < 2) return [];
    
    const result = await searchAds({ variables: { search: searchText, supplierType } });
    return result.data?.supplierProducts.nodes.map(supplierProduct => ({
      value: supplierProduct.id,
      label: supplierProduct.name[Object.keys(supplierProduct.name)[0]]
    })) || [];
  };
  return (
    <SearchSelect<{ value: string, label: string }>
      loadOptions={loadAds}
      value={selectedSupplierProduct || null}
      onSelect={(option) => onSupplierProductChange(option)}
      onClear={() => onSupplierProductChange(null)}
      renderOption={(option, selectCallback) => (
        <div className='px-2 py-1' onClick={selectCallback}>{option.label}</div>
      )}
      renderSelected={(option) => option.label}
      label="Product"
      placeholder="Search for a product..."
    />
  )
}